import type { QueryField } from '@/app/components/query-builder/types';

export const createSignalDateQueryField = (): QueryField => ({
  name: 'signal_at',
  label: 'Date',
  type: 'date',
  operators: ['>=', '<=', 'between'],
  disableFutureDates: true,
  defaultValue: '',
});

export const createSignalTypeQueryField = (): QueryField => ({
  name: 'type',
  label: 'Signal Type',
  type: 'select',
  operators: ['=', 'in', 'notIn'],
  options: ['form', 'page'].map(value => ({
    value,
    label: value.charAt(0).toUpperCase() + value.slice(1),
  })),
  defaultValue: '',
});
